import { type ReactElement, useCallback } from 'react'
import type AccordionProps from './accordion.props'
import arrow from './assets/faq-arrow.svg'
import * as S from './faq-accordion.styled'

export default function FaqAccordion ({ isOpen = false, ...props }: AccordionProps): ReactElement {
  const handleOpen = useCallback(() => {
    if (!isOpen) {
      props.onOpen(props.index)
      return
    }

    props.onOpen(undefined)
  }, [isOpen, props.index, props.onOpen])

  return <S.Container>
    <div className="title-container" onClick={handleOpen}>
      <div>
        <p>{props.title}</p>
      </div>
      <img src={arrow} alt="" className={`icon ${isOpen ? 'open' : ''}`} />
    </div>
    <div className={`content ${isOpen ? 'open' : ''}`}>
      {props.children}
    </div>
  </S.Container>
}
